export const ra = {
  pets: {
    teresa: {
      id: "teresa",
      name: "Тереза",
      nameDat: "Терезе",
      nameRod: "Терезы",
      color: "#8596ea",
      chunkGain: "Очках Вечности",
      memoryGain: "текущих МР",
      requiredUnlock: () => undefined,
      rawMemoryChunksPerSecond: () => 4 * Math.pow(Currency.eternityPoints.value.pLog10() / 1e4, 3),
      memoryProductionMultiplier: () => Ra.unlocks.teresaXP.effectOrDefault(1)
    },
    effarig: {
      id: "effarig",
      name: "Эффариг",
      nameRod: "Эффарига",
      nameDat: "Эффаригу",
      color: "#ea8585",
      chunkGain: "Заработанных Осколках Реликвий",
      memoryGain: "лучшем уровне Глифа",
      requiredUnlock: () => Ra.unlocks.effarigUnlock,
      rawMemoryChunksPerSecond: () => 4 * Math.pow(Effarig.shardsGained, 0.1),
      memoryProductionMultiplier: () => Ra.unlocks.effarigXP.effectOrDefault(1)
    },
    enslaved: {
      id: "enslaved",
      name: "Безымянные",
      nameRod: "Безымянных",
      nameDat: "Безымянным",
      color: "#f1aa7f",
      chunkGain: "Осколках Времени",
      memoryGain: "общем сыгранном времени",
      requiredUnlock: () => Ra.unlocks.enslavedUnlock,
      rawMemoryChunksPerSecond: () => 4 * Math.pow(Currency.timeShards.value.pLog10() / 3e5, 2),
      memoryProductionMultiplier: () => Ra.unlocks.enslavedXP.effectOrDefault(1)
    },
    v: {
      id: "v",
      name: "Ви",
      nameRod: "Ви",
      nameDat: "Ви",
      color: "#ead584",
      chunkGain: "Мощности Бесконечности",
      memoryGain: "общем уровне Воспоминаний",
      requiredUnlock: () => Ra.unlocks.vUnlock,
      rawMemoryChunksPerSecond: () => 4 * Math.pow(Currency.infinityPower.value.pLog10() / 1e7, 1.5),
      memoryProductionMultiplier: () => Ra.unlocks.vXP.effectOrDefault(1)
    }
  },
  unlocks: {
    autoTP: {
      id: 0,
      reward: "Тахион Частицы даются сразу, как только Растяжение Времени активируется",
      pet: "teresa",
      level: 1,
      displayIcon: `<span class="fas fa-atom"></span>`,
      disabledByPelle: true
    },
    chargedInfinityUpgrades: {
      id: 1,
      reward: () => `Разблокировать Заряженные Улучшения Бесконечности. Вы получаете +1 к максимульному
        количеству Заряженных Улучшений Бесконечности каждые ${formatInt(2)} уровней`,
      effect: () => Math.min(12, Math.floor(Ra.pets.teresa.level / 2)),
      pet: "teresa",
      level: 2,
      displayIcon: `<span class="fas fa-infinity"></span>`,
      disabledByPelle: true
    },
    teresaXP: {
      id: 2,
      reward: "Все Куски Памяти производят больше Воспоминаний, основываясь на Машинах Реальности",
      effect: () => 1 + Math.pow(Currency.realityMachines.value.pLog10() / 100, 0.5),
      pet: "teresa",
      level: 5,
      displayIcon: `Ϟ`
    },
    alteredGlyphs: {
      id: 3,
      reward: "Разблокируйте Изменённые Глифы, дающие новые эффекты Глифам, основываясь на Жертвоприношении Глифов",
      pet: "teresa",
      level: 10,
      displayIcon: `<span class="fas fa-bolt"></span>`,
      disabledByPelle: true
    },
    effarigUnlock: {
      id: 4,
      reward: "Разблокировать воспоминания Эффарига",
      pet: "teresa",
      level: 8,
      displayIcon: `Ϙ`
    },
    perkShopIncrease: {
      id: 5,
      reward: "Ограничения покупок подняты в Магазине Очков Перков Терезы",
      pet: "teresa",
      level: 15,
      displayIcon: `<span class="fas fa-project-diagram"></span>`
    },
    unlockDilationStartingTP: {
      id: 6,
      reward: `В не-Божественных Реальностях, получайте Тахион Частицы со скоростью, с которой получали бы их, как если
        бы вы достигли квадратного корня от вашего количества антиматерии в Растяжении Любые множители к заработку ТЧ
        применяются ретроактивно, даже снаружи Растяжения`,
      effect: () => player.records.totalAntimatter.pow(0.5),
      pet: "teresa",
      level: 25,
      displayIcon: `<i class="far fa-dot-circle"></i>`
    },
    extraGlyphChoicesAndRelicShardRarityAlwaysMax: {
      id: 7,
      reward: () => `Получите ${formatX(2)} вариантов выбора Глифа. Бонус к редкости Глифов от Осколков Реликвий
        всегда максимален`,
      effect: 2,
      pet: "effarig",
      level: 1,
      displayIcon: `<i class="fas fa-grip-horizontal"></i>`
    },
    unlockGlyphAlchemy: {
      id: 8,
      reward: `Разблокируйте Алхимию Глифов, которая добавляет алхимические ресурсы, которые в можете повышать путем
        Переработки Глифов. Вы разблокируете больше ресурсов через уровни Эффарига. Доступ через новую вкладку
        Реальности.`,
      pet: "effarig",
      level: 2,
      displayIcon: `<span class="fas fa-vial"></span>`
    },
    effarigXP: {
      id: 9,
      reward: "Все Куски Памяти производят больше Памяти на основе наибольшего уровня Глифа",
      effect: () => 1 + player.records.bestReality.glyphLevel / 7000,
      pet: "effarig",
      level: 5,
      displayIcon: `<span class="fas fa-clone"></span>`
    },
    glyphEffectCount: {
      id: 10,
      reward: () => `Глифы всегда имеют ${
        formatInt(4)} эффекта, а Глифы Эффарига теперь могут иметь до ${formatInt(7)}`,
      pet: "effarig",
      level: 10,
      displayIcon: `<span class="fas fa-braille"></span>`
    },
    enslavedUnlock: {
      id: 11,
      reward: "Разблокируйте Воспоминания Безымянных",
      pet: "effarig",
      level: 8,
      displayIcon: `<span class="c-ra-pet-milestones-effarig-link">\uf0c1</span>`
    },
    relicShardGlyphLevelBoost: {
      id: 12,
      reward: "Уровень Глифа повышен на основе заработанных Осколков Реликвий",
      effect: () => 100 * Math.pow(Math.log10(Math.max(Effarig.shardsGained, 1)), 2),
      pet: "effarig",
      level: 15,
      displayIcon: `<span class="fas fa-fire"></span>`
    },
    maxGlyphRarityAndShardSacrificeBoost: {
      id: 13,
      reward: () => `Глифы всегда генерируются с ${formatPercents(1)} редкостью, а
        степень заработка с Жертвования Глифов повышена на основе Осколков Реликвий`,
      effect: () => 1 + Effarig.maxRarityBoost / 100,
      pet: "effarig",
      level: 25,
      displayIcon: `<i class="fas fa-ankh"></i>`
    },
    blackHolePowerAutobuyers: {
      id: 14,
      reward: "Разблокировать АвтоПокупщики улучшения мощности Чёрных Дыр",
      pet: "enslaved",
      level: 1,
      displayIcon: `<span class="fas fa-circle"></span>`,
      disabledByPelle: true
    },
    improvedStoredTime: {
      id: 15,
      reward: "Накопленное игровое время усилено и вы можете копить больше реального времени. Повышается с уровнем " +
        "Безымянных",
      effects: {
        gameTimeAmplification: () => Math.pow(20, Math.clampMax(Ra.pets.enslaved.level, Ra.levelCap)),
        realTimeCap: () => 1000 * 3600 * Ra.pets.enslaved.level,
      },
      pet: "enslaved",
      level: 2,
      displayIcon: `<span class="fas fa-history"></span>`,
      disabledByPelle: true
    },
    enslavedXP: {
      id: 16,
      reward: "Все Куски Памяти производят больше Памяти на основе общего сыгранного времени",
      effect: () => 1 + Math.log10(player.records.totalTimePlayed) / 200,
      pet: "enslaved",
      level: 5,
      displayIcon: `<span class="fas fa-stopwatch"></span>`
    },
    autoPulseTime: {
      id: 17,
      reward: () => `Зарядка Чёрной Дыры теперь использует только ${formatPercents(0.99)} от вашего игрового времени и
        вы можете автоматически разряжать ${formatPercents(0.01)} вашего накопленного игрового времени каждые
        ${formatInt(5)} тиков.`,
      pet: "enslaved",
      level: 10,
      displayIcon: `<span class="fas fa-expand-arrows-alt"></span>`,
      disabledByPelle: true
    },
    vUnlock: {
      id: 18,
      reward: "Разблокировать Воспоминания Ви",
      pet: "enslaved",
      level: 8,
      displayIcon: `⌬`
    },
    peakGamespeedDT: {
      id: 19,
      reward: "Зарабатывать больше Растянутого Времени на основе пиковой скорости игры в каждой Реальности",
      effect: () => Math.max(Math.pow(Math.log10(player.celestials.ra.peakGamespeed) - 90, 3), 1),
      pet: "enslaved",
      level: 15,
      displayIcon: `<span class="fas fa-tachometer-alt"></span>`,
      disabledByPelle: true
    },
    allGamespeedGlyphs: {
      id: 20,
      reward: `Все базовые Глифы получают эффект ускорения скорости от Глифов Времени,
        а Глифы Времени получают дополнительный эффект`,
      pet: "enslaved",
      level: 25,
      displayIcon: `<span class="fas fa-clock"></span>`,
      onUnlock: () => {
        const allGlyphs = player.reality.glyphs.active.concat(player.reality.glyphs.inventory);
        for (const glyph of allGlyphs) {
          Glyphs.applyGamespeed(glyph);
        }
      }
    },
    instantECAndRealityUpgradeAutobuyers: {
      id: 21,
      reward: "Многоразовые улучшения Реальности покупаются автоматически, а Авто Вечные Челленджи работают мгновенно",
      pet: "v",
      level: 1,
      displayIcon: `<span class="fas fa-sync-alt"></span>`,
      disabledByPelle: true
    },
    autoUnlockDilation: {
      id: 22,
      reward: () => `В не-Божественных Реальностях, Растянутое Время бесплатно автоматически разблокируется после
        ${formatInt(TimeStudy.dilation.totalTimeTheoremRequirement)} Временных Теорем`,
      pet: "v",
      level: 2,
      displayIcon: `<span class="fas fa-fast-forward"></span>`
    },
    vXP: {
      id: 23,
      reward: "Все Куски Памяти производят больше Воспоминаний на основе общих уровней Божеств.",
      effect: () => 1 + Ra.totalPetLevel / 50,
      pet: "v",
      level: 5,
      displayIcon: `<span class="fas fa-book"></span>`
    },
    unlockHardV: {
      id: 24,
      reward: () => `Разблокируйте Достижения Сложного Ви и разблокируйте Исследование Триад каждые ${formatInt(6)}
        уровней. Исследования Триад расположены внизу вкладки Временных Исследований`,
      effect: () => Math.floor(Ra.pets.v.level / 6),
      pet: "v",
      level: 6,
      displayIcon: `<span class="fas fa-trophy"></span>`,
      disabledByPelle: true
    },
    continuousTTBoost: {
      id: 25,
      reward: "Временные Теоремы усклояют все формы продолжительного не-измерительного производства",
      effects: {
        ttGen: () => Math.pow(10, 5 * Ra.theoremBoostFactor()),
        eternity: () => Math.pow(10, 2 * Ra.theoremBoostFactor()),
        infinity: () => Math.pow(10, 15 * Ra.theoremBoostFactor()),
        replicanti: () => Math.pow(10, 20 * Ra.theoremBoostFactor()),
        dilatedTime: () => Math.pow(10, 3 * Ra.theoremBoostFactor()),
        memories: () => 1 + Ra.theoremBoostFactor() / 50,
        memoryChunks: () => 1 + Ra.theoremBoostFactor() / 50,
        autoPrestige: () => 1 + 2.4 * Ra.theoremBoostFactor()
      },
      pet: "v",
      level: 10,
      displayIcon: `<span class="fas fa-university"></span>`,
      disabledByPelle: true
    },
    achievementTTMult: {
      id: 26,
      reward: "Множитель Достижений применяется к генерации Временных Теорем",
      effect: () => Achievements.power,
      pet: "v",
      level: 15,
      displayIcon: `<span class="fas fa-graduation-cap"></span>`,
      disabledByPelle: true
    },
    achievementPower: {
      id: 27,
      reward: () => `Множитель Достижений поднят на ${formatPow(1.5, 1, 1)}`,
      effect: 1.5,
      pet: "v",
      level: 25,
      displayIcon: `<i class="fab fa-buffer"></i>`,
      disabledByPelle: true
    }
  }
};
